import React, { useEffect, useState } from 'react'

import axios from 'axios'

export const Matomo = ({ uuid }: {uuid: string}) => {
  const url = `${process.env.REACT_APP_API_HOST}/matomo/${uuid}`
  const [uniqueViews, setUniqueViews] = useState<string>()

  const loadData = async () => {
    try {
      const response = await axios.get(url)
      const hits = response.data.nb_hits
      setUniqueViews(`${hits.toString()} view${hits !== 1 ? 's' : ''}`)
    } catch (ex) {
      setUniqueViews('View count unavailable')
    }
  }

  useEffect(() => { loadData() }, [uuid])

  if (!uniqueViews) return null

  return (
    <button disabled className='reference-text' style={{ marginBottom: '0.5em' }}>
      {uniqueViews}
    </button>
  )
}
